import {
  DetailAction,
  DetailActions,
  DetailStoreConfig,
  DetailStoreState
} from './DetailTypes';

/**
 * Implicitní funkce pro načtení data key.
 * @returns {*|null|number|string}
 */
function getDataKey(this: DetailStoreState) {
  let dataKey = '';

  // Filter
  dataKey += JSON.stringify(this.filter);

  // Parent id
  dataKey += '_' + this.id;

  // ---

  return dataKey;
}

const initialState: DetailStoreState = {
  data: null,
  id: null,
  isFetching: false,
  fetched: false,
  currentDataKey: '',
  filter: {}, // pokud je detai zobrazován na základě filtru
  getDataKey,
  reducer: detail
};

export default function detail(
  state: DetailStoreState = initialState,
  action: DetailAction = {type: "INIT"},
  config?: DetailStoreConfig
): DetailStoreState {
  // Konfigurace
  if (config) {
    state = { ...state };

    if (config.filter) {
      // inicializační filtr
      state.filter = config.filter;
    }
  }

  switch (action.type) {
    case DetailActions.REQUEST:
      return {
        ...state,
        isFetching: true,
        currentDataKey: action.dataKey as string
      };
    case DetailActions.RESPONSE: {
      return {
        ...state,
        isFetching: false,
        fetched: true,
        data: action.data
      };
    }
    case DetailActions.FILTER: {
      return {
        ...state,
        filter: action.filter
      };
    }
    case DetailActions.SELECT: {
      return {
        ...state,
        id: action.id,
        data: state.id === action.id ? state.data : null,
        fetched: state.id === action.id ? state.fetched : false
      };
    }
    case DetailActions.INVALIDATE: {
      if (action.id === state.id) {
        return {
          ...state,
          currentDataKey: initialState.currentDataKey
        };
      } else {
        return state;
      }
    }
    case DetailActions.UPDATE_VALUE: {
      return {
        ...state,
        data: action.data
      };
    }
    case DetailActions.RESET: {
      return {
        ...initialState,
        filter: config && config.filter ? config.filter : initialState.filter
      };
    }
    default:
      return state;
  }
}
